import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BookingIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BookingIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M10.8435 21.1936H5.17789C3.67398 21.1936 2.4502 20.0203 2.4502 18.5779V6.89832C2.4502 5.45588 3.67398 4.28259 5.17789 4.28259H18.1703C19.6742 4.28259 20.898 5.45588 20.898 6.89832V11.4159C20.898 11.695 20.6626 11.9208 20.3716 11.9208C20.0807 11.9208 19.8453 11.695 19.8453 11.4159V6.89832C19.8453 6.01294 19.0939 5.29221 18.1703 5.29221H5.17788C4.25426 5.29221 3.50282 6.01294 3.50282 6.89832V18.5779C3.50282 19.4633 4.25426 20.184 5.17788 20.184H10.8435C11.1344 20.184 11.3698 20.4098 11.3698 20.6888C11.3698 20.9678 11.1344 21.1936 10.8435 21.1936Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.3213 10.0898H3.02687C2.73595 10.0898 2.50055 9.86406 2.50055 9.58503C2.50055 9.30601 2.73595 9.08023 3.02687 9.08023H20.3213C20.6122 9.08023 20.8476 9.30601 20.8476 9.58503C20.8476 9.86406 20.6122 10.0898 20.3213 10.0898Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.9082 7.07382C15.6173 7.07382 15.3819 6.84804 15.3819 6.56901V3.00481C15.3819 2.72578 15.6173 2.5 15.9082 2.5C16.1992 2.5 16.4346 2.72578 16.4346 3.00481V6.56901C16.4346 6.84804 16.1992 7.07382 15.9082 7.07382Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.43991 7.07382C7.14899 7.07382 6.91359 6.84804 6.91359 6.56901V3.00481C6.91359 2.72578 7.14899 2.5 7.43991 2.5C7.73082 2.5 7.96622 2.72578 7.96622 3.00481V6.56901C7.96622 6.84804 7.73082 7.07382 7.43991 7.07382Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.572 22.5C14.8823 22.5 12.6943 20.4009 12.6943 17.8207C12.6943 15.2414 14.8823 13.1423 17.572 13.1423C17.9529 13.1423 18.3337 13.1847 18.7028 13.2695C18.9854 13.3336 19.1602 13.6067 19.0929 13.8779C19.0261 14.15 18.7428 14.3225 18.4591 14.2515C18.1693 14.1855 17.8711 14.152 17.572 14.152C15.4626 14.152 13.747 15.7975 13.747 17.8207C13.747 19.8439 15.4626 21.4904 17.572 21.4904C19.6814 21.4904 21.3976 19.8439 21.3976 17.8207C21.3976 17.5417 21.633 17.3159 21.9239 17.3159C22.2148 17.3159 22.4502 17.5417 22.4502 17.8207C22.4502 20.4009 20.2617 22.5 17.572 22.5Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.6234 19.2178C17.4841 19.2178 17.3499 19.1645 17.2513 19.0699L15.7597 17.6403C15.5541 17.4431 15.5541 17.1236 15.7597 16.9264C15.9653 16.7292 16.2983 16.7292 16.5039 16.9264L17.6075 17.9834L21.4613 13.9617C21.6592 13.7566 21.9917 13.7448 22.205 13.9311C22.4188 14.1194 22.4332 14.4389 22.2364 14.644L18.0109 19.0541C17.9138 19.1557 17.7781 19.2148 17.6347 19.2178H17.6234Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BookingIcon;
